<template>
  <section class="vbox">    
    <section class="scrollable wrapper">
      <div class="content-header">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item><a href="/">运营</a></el-breadcrumb-item>
          <el-breadcrumb-item>返点分配设置</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-form ref="form" label-width="260px">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>本商家会员到店消费返点分配</span>
          </div>
          <el-form-item label="会员分润比列">
            <el-col :span="8">
              <el-input  v-model="oneselfStore.member"  :min="0" :max="100">
                <el-button slot="append">%</el-button>
              </el-input >   
            </el-col>
          </el-form-item> 
          <el-form-item label="会员归属商家分润比列">
            <el-col :span="8">
              <el-input  v-model="oneselfStore.memberStore"  :min="0" :max="100">
                <el-button slot="append">%</el-button>
              </el-input >   
            </el-col>
          </el-form-item> 
          <el-form-item label="会员一级推荐人分润">
            <el-col :span="8">
              <el-input  v-model="oneselfStore.firstMemberRecommend"  :min="0" :max="100">
                <el-button slot="append">%</el-button>
              </el-input >   
            </el-col>
          </el-form-item> 
          <el-form-item label="会员二级推荐人分润">
            <el-col :span="8">
              <el-input  v-model="oneselfStore.secondMemberRecommend"  :min="0" :max="100">
                <el-button slot="append">%</el-button>
              </el-input >   
            </el-col>
          </el-form-item> 
          <el-form-item label="介绍者分润">
            <el-col :span="8">
              <el-input  v-model="oneselfStore.shareMemberRecommend"  :min="0" :max="100">
                <el-button slot="append">%</el-button>
              </el-input >   
            </el-col>
          </el-form-item> 
          <el-form-item >
            <el-col :span="8">
              <el-button type="primary" @click="saveOneselfStore">确 定</el-button>
            </el-col>
          </el-form-item>
        </el-card>
        <el-card class="box-card top8">
          <div slot="header" class="clearfix">
            <span>其他商家会员到店消费返点分配</span>
          </div>
          <el-form-item label="会员分润比列">
            <el-col :span="8">
              <el-input  v-model="otherStore.member"  :min="0" :max="100">
                <el-button slot="append">%</el-button>
              </el-input >   
            </el-col>
          </el-form-item> 
          <el-form-item label="会员归属商家分润比列">
            <el-col :span="8">
              <el-input  v-model="otherStore.memberStore"  :min="0" :max="100">
                <el-button slot="append">%</el-button>
              </el-input >   
            </el-col>
          </el-form-item> 
          <el-form-item label="会员一级推荐人分润">
            <el-col :span="8">
              <el-input  v-model="otherStore.firstMemberRecommend"  :min="0" :max="100">
                <el-button slot="append">%</el-button>
              </el-input >   
            </el-col>
          </el-form-item> 
          <el-form-item label="会员二级推荐人分润">
            <el-col :span="8">
              <el-input  v-model="otherStore.secondMemberRecommend"  :min="0" :max="100">
                <el-button slot="append">%</el-button>
              </el-input >   
            </el-col>
          </el-form-item> 
          <el-form-item label="介绍者分润">
            <el-col :span="8">
              <el-input  v-model="otherStore.shareMemberRecommend"  :min="0" :max="100">
                <el-button slot="append">%</el-button>
              </el-input >   
            </el-col>
          </el-form-item> 
          <el-form-item >
            <el-col :span="8">
              <el-button type="primary" @click="saveOtherStore">确 定</el-button>
            </el-col>
          </el-form-item>
        </el-card>
        <el-card class="box-card top8">
          <div slot="header" class="clearfix">
            <span>线上引流消费返点分配</span>
          </div>
          <el-form-item label="会员分润比列">
            <el-col :span="8">
              <el-input  v-model="platform.member"  :min="0" :max="100">
                <el-button slot="append">%</el-button>
              </el-input >   
            </el-col>
          </el-form-item> 
          <el-form-item label="会员归属商家分润比列">
            <el-col :span="8">
              <el-input  v-model="platform.memberStore"  :min="0" :max="100">
                <el-button slot="append">%</el-button>
              </el-input >   
            </el-col>
          </el-form-item> 
          <el-form-item label="会员一级推荐人分润">
            <el-col :span="8">
              <el-input  v-model="platform.firstMemberRecommend"  :min="0" :max="100">
                <el-button slot="append">%</el-button>
              </el-input >   
            </el-col>
          </el-form-item> 
          <el-form-item label="会员二级推荐人分润">
            <el-col :span="8">
              <el-input  v-model="platform.secondMemberRecommend"  :min="0" :max="100">
                <el-button slot="append">%</el-button>
              </el-input >   
            </el-col>
          </el-form-item> 
          <el-form-item label="介绍者分润">
            <el-col :span="8">
              <el-input  v-model="platform.shareMemberRecommend"  :min="0" :max="100">
                <el-button slot="append">%</el-button>
              </el-input >   
            </el-col>
          </el-form-item> 
          <el-form-item >
            <el-col :span="8">
              <el-button type="primary" @click="savePlatform">确 定</el-button>
            </el-col>
          </el-form-item>
        </el-card>
      </el-form>
    </section>    
  </section>
</template>
<script  type='text/ecmascript-6'>
  import { Message } from 'element-ui'
  export default {
    props:{
    },
    data (){
      return {
        oneselfStore:{},
        otherStore:{},
        platform:{}
      }
    },
    computed:{
    },
    mounted(){
      var that = this
      this.axios({
        method:'get',
        url:that.global.serverSrc + '/api/Financial/GetDistributionRule',         
        params:{
          id:that.$route.params.Id
        }
      }).then(function (resp) {
        that.oneselfStore = resp.data.oneselfStore
        that.otherStore = resp.data.otherStore
        that.platform = resp.data.platform
      })
    },
    methods:{     
      saveOneselfStore(){
        this.SaveDistributionRule(this.oneselfStore)
      },
      saveOtherStore(){
        this.SaveDistributionRule(this.otherStore)
      },
      savePlatform(){
        this.SaveDistributionRule(this.platform)
      },
      SaveDistributionRule:function(obj){
        var that = this
        this.axios({
          method:'post',
          url:that.global.serverSrc + '/api/Financial/SaveDistributionRule',         
          data:obj
        }).then(function (resp) {
          if(resp.data.errorCode==0){
            that.$message.success(resp.data.message);
          }else {
            that.$message.warning(resp.data.message);
          }  
        }).catch(resp => {         
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      
    },
    components:{
      
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
  .content-header
    padding 24px
    border 1px solid #C0C4CC
    margin-bottom 24px
  .top8
    margin-top 8px
</style>